<template>
  <div>
    <app-scroll-top></app-scroll-top>
    <app-header></app-header>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>
import ScrollTop from './components/ScrollTop';
import Header from './components/Header';
import Footer from './components/Footer/index';

export default {
  components: {
    'app-scroll-top': ScrollTop,
    'app-header': Header,
    'app-footer': Footer,
  },
};
</script>

<style lang="scss">
  @import './styles/index.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue